import { render, staticRenderFns } from "./AgreementProductCosts.vue?vue&type=template&id=18fd66ba&scoped=true&"
import script from "./AgreementProductCosts.vue?vue&type=script&lang=js&"
export * from "./AgreementProductCosts.vue?vue&type=script&lang=js&"
import style0 from "./AgreementProductCosts.vue?vue&type=style&index=0&id=18fd66ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd66ba",
  null
  
)

export default component.exports